import { useMemo } from 'react';
import { getInitials } from '@dtvgo/utils';
import './CardProfile.scss';
import { jsxs, jsx } from 'react/jsx-runtime';

/* External */
function CardProfile(_ref) {
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'blue' : _ref$color,
    _ref$nameUser = _ref.nameUser,
    nameUser = _ref$nameUser === void 0 ? true : _ref$nameUser,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? null : _ref$onClick;
  var logoLetter = useMemo(function () {
    return getInitials(name).slice(0, 2).join('').toUpperCase();
  }, [name]);
  return /*#__PURE__*/jsxs("button", {
    type: "button",
    className: "dtv-common-c-card-profile",
    onClick: onClick,
    children: [/*#__PURE__*/jsx("div", {
      className: "dtv-common-c-card-profile__logo dtv-common-c-card-profile__logo--".concat(color, " ").concat(className),
      children: logoLetter
    }), /*#__PURE__*/jsx("div", {
      className: "dtv-common-c-card-profile__name ".concat(nameUser ? '' : 'hide'),
      children: name
    })]
  });
}

export { CardProfile as default };
//# sourceMappingURL=CardProfile.js.map
